import { Routes } from '@angular/router';
import { ServiceRequestListComponent } from './pages/service-request-list/service-request-list.component';
import { ServiceRequestUpdateComponent } from './pages/service-request-update/service-request-update.component';
import { serviceRequestResolver } from './resolvers/service-request.resolver';
import { serviceRequestsResolver } from './resolvers/service-requests.resolver';

export const requestsRoutes: Routes = [
  {
    path: 'utilities/service-requests',
    title: 'Service requests',
    component: ServiceRequestListComponent,
    resolve: {
      serviceRequests: serviceRequestsResolver,
    },
  },
  {
    path: 'utilities/service-requests/:id',
    title: 'Service request',
    component: ServiceRequestUpdateComponent,
    resolve: {
      serviceRequest: serviceRequestResolver,
    },
  },
];
